import React from "react"
import {BannerInnerContainer} from "./components"

export const StandardStaticBannerInnerContainer = ({children}) => {
    return <BannerInnerContainer>{children}</BannerInnerContainer>
}

export default StandardStaticBannerInnerContainer
